const REASONS = [
  {
    icon: 'ri-shield-check-line',
    title: 'Privacy Without Isolation',
    desc: 'The cabin sits in a secluded wooded setting that genuinely feels private — no neighbors in view, no road noise — while still being just a few minutes\' drive from downtown Highlands and Main Street. That balance is rare and hard to find.',
  },
  {
    icon: 'ri-drop-line',
    title: 'Walking Distance to Glen Falls',
    desc: 'Glen Falls is one of the most beautiful waterfalls in the Blue Ridge Mountains, and this cabin is within walking distance of the trailhead. Most vacation rentals in Highlands, NC require a drive to reach the falls — this one doesn\'t.',
  },
  {
    icon: 'ri-home-4-line',
    title: 'Genuine Luxury Feel',
    desc: 'The interior is thoughtfully designed — not just "nice for a cabin." Stone fireplace, quality furnishings, a full gourmet kitchen, and an outdoor wood-burning fireplace on the covered deck. It feels like a real retreat, not a rental.',
  },
  {
    icon: 'ri-star-line',
    title: '5.0 Guest Favorite Rating',
    desc: 'A 5.0-star Airbnb Guest Favorite rating is genuinely difficult to maintain. Guests consistently note the quality of the space, the peaceful setting, and the attentive hosting — not just in one or two reviews, but consistently over time.',
  },
  {
    icon: 'ri-footprint-line',
    title: 'Pet Friendly',
    desc: 'The cabin welcomes pets, which matters a lot for travelers who want to bring their dogs. The wooded setting and nearby trails make it a particularly good fit for pet owners.',
  },
  {
    icon: 'ri-group-line',
    title: 'Works for Different Groups',
    desc: 'Whether you\'re planning a romantic weekend for two, a family trip, or a small group getaway, the cabin accommodates up to 6 guests comfortably. It\'s not a one-size-fits-all rental — it genuinely works for different types of trips.',
  },
];

export default function VRWhyGlenFallsSection() {
  return (
    <section className="bg-[#EDE8E0] py-24 px-6 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">

          {/* Left — image */}
          <div className="rounded-2xl overflow-hidden h-[520px] lg:sticky lg:top-24">
            <img
              src="https://public.readdy.ai/ai/img_res/6977384fe190babed6a67831baf88866.jpg"
              alt="Glen Falls Luxury Cabin — top vacation rental in Highlands NC"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Right — content */}
          <div>
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Our Top Pick</p>
            <h2 className="font-cormorant text-4xl md:text-5xl text-[#1A1A18] font-light mb-4 leading-tight">
              Why Glen Falls Luxury Cabin<br /><em className="italic">Is Our #1 Recommendation</em>
            </h2>
            <div className="w-12 h-px bg-[#C9A96E] mb-7" />
            <p className="text-[#5C5850] font-jost text-sm leading-relaxed mb-10">
              There are several good cabin rentals in Highlands, NC, but Glen Falls Luxury Cabin earns the top spot because it gets the combination right in a way that most properties don&apos;t. Here&apos;s what sets it apart:
            </p>

            <div className="space-y-6">
              {REASONS.map((reason) => (
                <div key={reason.title} className="flex items-start gap-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white shrink-0 mt-0.5">
                    <i className={`${reason.icon} text-[#2D4A3E] text-base`} />
                  </div>
                  <div>
                    <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium mb-1.5">{reason.title}</h3>
                    <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{reason.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <a
                href="https://glenfallscabin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-[#2D4A3E] text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-8 py-4 rounded-full hover:bg-[#1e3329] transition-colors cursor-pointer whitespace-nowrap"
              >
                View Glen Falls Luxury Cabin
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-external-link-line text-xs" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
